import { Outlet, useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Scrollbar from "react-scrollbars-custom";
import { LegalDisclaimer } from "../global/LegalDisclaimer";
import NavMenu from "../global/components/NavMenu";
import { menuList } from "../model/appMenu";
import { Layout } from "antd";
import NewHeader from "./NewHeader";
import { isHavingNoPermission } from "../global/utility/checkPermission";
import { logout } from "../store/actions/auth";
import { shipmentLogout } from "../store/actions/shipment";
import LocationValidator from "../global/utility/LocationValidator";

const RootLayoutV2 = () => {
  const [left, setLeft] = useState(false);
  const [navmenu, setNavmenu] = useState("show");
  const [menus, setMenus] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    const oldAccountId = sessionStorage.getItem("oldAccountId");

     if ( location?.pathname?.startsWith("/assets") &&
      location?.pathname?.split("/")?.length > 1) {
      if (oldAccountId && oldAccountId !== user?.accountId) {
        sessionStorage.removeItem("oldAccountId");
        navigate("/assets", { replace: true });
      }
    }else if (location?.pathname?.startsWith("/viewshipment")) {
      if (oldAccountId && oldAccountId !== user?.accountId) {
        sessionStorage.removeItem("oldAccountId");
        navigate("/shipments", { replace: true });
      }
    } else if (
      location?.pathname?.startsWith("/devices") &&
      location?.pathname?.split("/")?.length > 1
    ) {
      if (oldAccountId && oldAccountId !== user?.accountId) {
        sessionStorage.removeItem("oldAccountId");
        navigate("/devices", { replace: true });
      }
    } else {
      sessionStorage.removeItem("oldAccountId");
    }
  }, [user?.accountId, navigate, location]);

  useEffect(() => {
    if (user && user?.bearerToken && user?.accountId) {
      const permissions = {
        ...user?.role?.permissions,
        shipments: {
          configure: false,
          create: true,
          delete: true,
          download: true,
          edit: true,
          view: true,
        },
        support: {
          view: true,
        },
      };
      // const roleBasedMenus = menuList["Manage"]
      //   .filter((menu) => permissions[menu.selector])
      //   .filter((menu) => !isHavingNoPermission(permissions[menu.selector]));
      const isAllTrue = (obj) => {
        if (!obj || typeof obj !== "object") return false;
        return Object.values(obj).every((value) => value === true);
      };
      const apiDocFullAccess = isAllTrue(permissions.apiDocumentation);
      const roleBasedMenus = menuList["Manage"].filter((menu) => {
        if (menu.name === "Device profile" || menu.name === "Shipments") {
          return apiDocFullAccess;
        }
        const selectorPermissions = permissions[menu.selector];
        return (
          selectorPermissions && !isHavingNoPermission(selectorPermissions)
        );
      });
      setMenus(roleBasedMenus);
    } else {
      sessionStorage.clear();
      //revokeTokenApi(user?.bearerToken);
      dispatch(logout());
      localStorage.removeItem("lasActivity");
      dispatch(shipmentLogout());
      navigate("/login");
      return;
    }
  }, [user, navigate]);

  const updateActivity = () => {
    if (user === null) return;
    localStorage.setItem("lasActivity", Date.now().toString());
  };

  return (
    <div className="sasp-d-flex">
      <LocationValidator />
      <NewHeader left={left} setLeft={setLeft} navmenu={navmenu} />
      <div className="sasp_d-flex" style={{ minHeight: "100vh" }}>
        <div
          style={{
            background: "#000",
            color: "#fff",
            maxWidth: "15%",
            minWidth: left ? "2%" : "14.1%",
            paddingBottom: "50px",
            paddingTop: "25px",
            fontSize: ".875rem",
            borderRight: "0.5px solid black",
          }}
        >
          <NavMenu left={left} menuItems={menus} menuName="Manage" />
        </div>
        <Layout className="site-layout" style={{ flex: 1 }}>
          {/* <Scrollbar onScroll={updateActivity} className="custom-scrollbar"> */}
          <div
            style={{
              padding: "24px",
              background: "#f6f6f6",
            }}
            onScroll={updateActivity}
          >
            <Outlet />
            {LegalDisclaimer()}
          </div>
          {/* </Scrollbar> */}
        </Layout>
      </div>
    </div>
  );
};

export default RootLayoutV2;
